export const environment = {
  production: false,
  proxyUrls: {
    productionApi: "https://production.api.sierra-erp.com",
    userMasterApi: "https://user.api.sierra-erp.com",
  },
  dashboard: {
    fetchInterval: 180000,
    cycleTime: 30000,
    shiftOverlayDuration: 10000,
    views: {
      currentCustomers: { index: 0, enabled: false },
      workOrdersProgress: { index: 1, enabled: false },
      closedKnittingOrders: { index: 2, enabled: true },
      knittingOrderProgress: { index: 3, enabled: true },
      rejectedKnittingOrders: { index: 4, enabled: true },
      machineProductionRate: { index: 5, enabled: true },
      shiftAnnouncement: { index: 6, enabled: true },
      rejectedMachines: { index: 7, enabled: false },
    },
  },
};
